<template>
  <div class="choose-seat-flow">
    <!-- Every purchase path flow starts at this screen -->
    <choose-date-time v-if="showChooseDateTime"/>

    <!-- Only GA (free) doesn't hit this -->
    <seating-area v-if="showSeatingArea" @chooseArea="chooseArea"/>

    <!-- RS mode only (Reserved Seat, i.e. Seat Pick) -->
    <choose-seats v-if="showChooseSeats"/>

    <!-- BA & HS modes only, hit both ticket-quantity & then seat-preview (Best Available / Hot Show)-->
    <ticket-quantity v-if="showTicketQuantity"/>
    <seat-preview v-if="showSeatPreview" @submitSetSelection="submitSetSelection" />

    <!-- Every flow hits this point -->
    <choose-tickets v-if="showChooseTickets"/>
  </div>
</template>

<script>
import ChooseDateTime from "@/views/ChooseDateTime";
import SeatingArea from "@/views/seating-area/SeatingArea";
import ChooseSeats from "@/views/seating-area/ChooseSeats";
import ChooseTickets from "@/views/ChooseTickets";
import TicketQuantity from "@/views/TicketQuantity";
import SeatPreview from "@/views/seating-area/SeatPreview";
import { mapState, mapActions } from "vuex";

export default {
  name: "ChooseSeatFlow",
  components: {
    ChooseDateTime,
    SeatingArea,
    ChooseSeats,
    ChooseTickets,
    TicketQuantity,
    SeatPreview,
  },
  created() {
    /*
     * IMPORTANT NOTE: Do not move the below to a later hook (https://vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
     * Because we have multiple 'views' technically sitting within one route (ChooseSeatFlow // name: "choose-seat-flow")
     * When we navigate to another event (i.e. ICC Code), the existing 'view' which is displayed, for example: Seating Area
     * Will fire its initial hooks again (beforeCreate, created, beforeMount, mounted), before switching to choose-date-time
     */
    if (this.$route.params.issue === "cart-addition-issue") {
      if (this.performance.mode == "") {
        // If cart-addition-issue is present in the URL
        // And we've already reset the performance store (resetPerformanceStore);
        // Then clear the URL so it doesn't look like there's an issue to users
        this.$router.push({
          name: "choose-seat-flow",
          params: { event: this.$route.params.icc, locale: this.$i18n.locale },
        });
      } else {
        this.updateStage("choose-tickets");
      }
    } else {
      this.updateStage("choose-date-time");
    }

    if (this.$route.params.issue !== "cart-addition-issue") {
      this.clearError();
    }

    if (current.stage !== "choose-tickets") {
      this.checkReservedTimer();
    }
  },
  methods: {
    chooseArea(event) {
      this.updateSeatSectionId(event.seatSectionId);
      this.updatePriceCategoryId(event.priceCategoryId);
      this.updateSeatingAreaNames({
        section: event.seatSectionName,
        level: event.seatLevelName,
      });

      if (event.seatSectionType === "RS") {
        if (this.performance.mode == "BA" || this.performance.mode == "HS") {
          this.updateProgressBarPath({
            key: "bestAvailableOrHotShow",
            value: true,
          });
          this.updateStage("ticket-quantity");
        } else {
          this.updateStage("choose-seats");
        }
      } else if (event.seatSectionType === "GA") {
        this.updateMode("GA");
        this.updateStage("choose-tickets");
      } else {
        this.updateError("unrecognized.seatsectiontype");
      }
    },
    goToEarlierStage(current) {
      if (current.stage == "seating-area") {
        this.updateStage("choose-date-time");
      }

      if (current.stage == "choose-seats") {
        this.updateStage("seating-area");
      }

      if(current.stage == "seat-preview") {
        // We're in BA/HS therefore we need to clear timer if we haven't got items in the cart
        this.clearSeatsReservedTimerCheck();
        this.updateStage("ticket-quantity")
      }

      if(current.stage == "ticket-quantity") {
        this.updateStage("seating-area");
      }

      if (current.stage == "choose-tickets") {
        if (this.performance.mode == "BA" || this.performance.mode == "HS") {
          this.updateStage("seat-preview");
        } else if (this.performance.mode == "GA") {
          this.updateStage(this.previousStage);
        } else {
          // We've reserved seats from the Choose Seats screen therefore we need to clear timer if we haven't got items in the cart
          this.clearSeatsReservedTimerCheck();
          this.updateStage("choose-seats");
        }
      }
    },
    submitSetSelection() {
      this.updateStage("choose-tickets");
    },
    ...mapActions([
      "updateStage",
      "updateError",
      "clearError",
      "updateMode",
      "updateSeatSectionId",
      "updatePriceCategoryId",
      "updateSeatingAreaNames",
      "updateProgressBarPath",
      "checkReservedTimer",
      "clearSeatsReservedTimerCheck"
    ]),
  },
  computed: {
    showChooseDateTime() {
      if (this.error == "date_times_retrieval_failed") {
        return false;
      } else if (this.stage == "choose-date-time") {
        return true;
      } else {
        return false;
      }
    },
    showSeatingArea() {
      if (this.stage == "seating-area") {
        return true;
      } else {
        return false;
      }
    },
    showChooseSeats() {
      if (this.error == "ticket_type_retrieval_failed") {
        return false;
      } else if (this.stage == "choose-seats") {
        return true;
      } else {
        return false;
      }
    },
    showChooseTickets() {
      if (this.error == "ticket_type_retrieval_failed") {
        return false;
      } else if (this.stage == "choose-tickets") {
        return true;
      } else {
        return false;
      }
    },
    showTicketQuantity() {
      if (this.stage == "ticket-quantity") {
        return true;
      } else {
        return false;
      }
    },
    showSeatPreview() {
      if (this.stage == "seat-preview") {
        return true;
      } else {
        return false;
      }
    },
    ...mapState(["error", "cart", "stage", "performance", "goBackValue", "previousStage"]),
  },
  watch: {
    goBackValue() {
      // This is a hack so we can use goBack button outside of the vue-router instance.
      this.goToEarlierStage({ stage: this.stage });
    }
  }
};
</script>
